
const api = { url: "https://test.api.arverasupport.nl/v1" };

const origin = { url: window.location.origin };

module.exports = { api, origin };
